export const isPlatformSwitcherEnabled = (): boolean =>
  import.meta.env.VITE_PLATFORM_SWITCHER_ENABLED === "true";

const normalizeUrl = (url: string): string =>
  url.replace(/\/$/, "").trim();

export const getAngularAppUrls = (): string[] => {
  const envValue =
    import.meta.env.VITE_REDIRECT_LOGIN_URL ||
    "http://localhost:4200";

  return envValue
    .split(",")
    .map((url: string) => normalizeUrl(url))
    .filter(Boolean);
};

export const getAngularAppUrl = (): string => {
  const urls = getAngularAppUrls();
  return urls[0] ?? "http://localhost:4200";
};

export const navigateToOtherPlatform = (): void => {
  const target = `${getAngularAppUrl()}${window.location.pathname}${window.location.search}`;
  window.location.assign(target);
};

export const PLATFORM_SWITCHER_BAR_COLLAPSED_KEY = "platform_switcher_bar_collapsed";
